"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const teamMembers = [{
  name: "Jon Trahan",
  position: "Master Craftsman & Founder",
  bio: "A licensed general contractor with 15 years of experience turning complex architectural visions into high-end residential realities.",
  image: "https://modern-joey.10web.cloud/wp-content/uploads/2026/05/Screenshot_20230118_135852_Tinder_Original-Copy-Copy.jpg",
  linkedin: "https://www.linkedin.com/"
}];
export default function OurExpertTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227779" id="meet-the-craftsmen" className="py-24 bg-background text-foreground overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-4 max-w-5xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-primary mb-4 tracking-tight">Meet the Owner</h2>
          <div className="w-24 h-1 bg-secondary mx-auto rounded-md opacity-80 mb-8"></div>
        </div>

        <div className="grid grid-cols-1 gap-12 md:gap-16">
          {teamMembers.map((member, i) => <div data-index={i} key={member.name} className="flex justify-center">
              <Card className="group border-none bg-transparent overflow-hidden w-full max-w-4xl">
                <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center md:items-start">
                  <div className="w-full md:w-1/2">
                    <div className="relative overflow-hidden rounded-md aspect-[3/4] mb-6 shadow-md">
                      <img src={member.image} alt={`Portrait of ${member.name}`} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 ease-in-out group-hover:scale-105" />
                      
                      <div className="absolute inset-0 bg-primary/95 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-8 text-center backdrop-blur-sm">
                        <p className="text-primary-foreground font-default text-base leading-relaxed mb-8 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                          {member.bio}
                        </p>
                        <Link to={member.linkedin} newTab className="text-secondary hover:text-secondary/80 transition-colors transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 duration-500 delay-200" aria-label={`${member.name}'s LinkedIn Profile`}>
                          <Linkedin className="w-8 h-8" strokeWidth={1} />
                        </Link>
                      </div>
                    </div>

                    <div className="text-center md:text-left">
                      <h3 className="font-default text-2xl font-semibold text-primary mb-2">
                        {member.name}
                      </h3>
                      <p className="font-default text-secondary font-medium tracking-widest uppercase text-xs">
                        {member.position}
                      </p>
                    </div>
                  </div>

                  <div className="flex-1 w-full md:w-1/2">
                    <p className="font-default text-base leading-relaxed text-muted-foreground mb-6">
                      With over 15 years of hands-on experience in the Denver metro area, Jon Trahan has built a reputation for transforming complex architectural concepts into stunning residential realities. As a licensed and insured general contractor, his expertise spans the entire lifecycle of a project—from initial floor plan design and 3D modeling to the final meticulous brushstroke.
                    </p>
                    <p className="font-default text-base leading-relaxed text-muted-foreground">
                      Jon's philosophy is rooted in the belief that every home should be a masterpiece of both form and function. Whether leading a whole-home remodel, crafting a custom ADU, or installing high-end epoxy coatings, he approaches every detail with the precision of a master craftsman. His commitment to quality and transparent communication ensures that every BT Remodeling project is not just a construction site, but a collaborative journey toward a client's dream home.
                    </p>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}